// "Unusual" flags on the coach's Preview in app: a column's top value that
// dwarfs everyone else's is usually a typo or a unit mix-up (a set logged in
// grams). Runs on the preview rows already loaded, no extra request.
// ponytail: top-value ratio only; per-day patterns (same steps every day)
// need daily data the board doesn't keep.

export const UNUSUAL_RATIO = 10;

// Capped at 100%, so never wildly out of range.
const SKIPPED_KEYS = new Set(["completionRate", "habitsAdherence"]);

export interface UnusualValue {
  key: string;
  value: number;
  next: number;
  ratio: number;
}

/** Flags by user id: at most one per member (their first flagged column). */
export const findUnusual = (
  columnKeys: string[],
  rows: { userId: string; values: Record<string, number | null> }[]
): Map<string, UnusualValue> => {
  const flags = new Map<string, UnusualValue>();
  for (const key of columnKeys) {
    if (SKIPPED_KEYS.has(key)) continue;
    let top: { userId: string; value: number } | null = null;
    let next = 0;
    for (const row of rows) {
      const value = row.values[key];
      if (typeof value !== "number" || value <= 0) continue;
      if (!top || value > top.value) {
        if (top) next = top.value;
        top = { userId: row.userId, value };
      } else if (value > next) {
        next = value;
      }
    }
    if (!top || next <= 0 || flags.has(top.userId)) continue;
    const ratio = top.value / next;
    if (ratio >= UNUSUAL_RATIO) {
      flags.set(top.userId, { key, value: top.value, next, ratio });
    }
  }
  return flags;
};
